<style lang="sass">
    @import ../../common/styles/mixins
    @import ../../common/styles/settings
    @import form-qualification

</style>

<script>

    export default {
        props: {
            dataProps: {
                type: String,
                default: ''
            }
        },

        data() {
            return {
                success: false,
                formEl: null,
                formError: '',
                formData: {
                    email: 'test@test.fr',
                    bottles	: [],
                    bottles_count: '',
                    use: [],
                    energy: '',
                    zipcode: ''
                },
                formLabels: {}
            }
        },

        created() {
            let props = JSON.parse(this.dataProps)
            this.formData.email = props.email ? props.email : 'test@test.fr'
            this.formLabels = !this.isObjectEmpty(props.labels) ? props.labels : {}

            this.$validator.localize('fr', {
                attributes: {
                    bottles_count: 'Le nombre de bouteilles',
                    zipcode: 'Le code postal'
                }
            })

        },

        mounted() {
            this.formEl = this.$el.querySelector('form')
            this.success = this.formEl.querySelector('.webform-confirmation') !== null
        },

        methods: {
            isObjectEmpty(o) {
                return Object.keys(o).length === 0 && o.constructor === Object
            },
            fillForm() {

                let inputs = this.formEl.querySelectorAll('input')
                inputs.forEach(i => {

                    let name = i.name.split('[')[0] || null

                    if (name && this.formData.hasOwnProperty(name)) {

                        let value = this.formData[name]

                        switch (i.type) {
                            case 'radio' :
                                if (i.value === value)
                                    i.setAttribute('checked', 'checked')
                                break
                            case 'checkbox' :
                                if (value.includes(i.value))
                                    i.setAttribute('checked', 'checked')
                                break
                            default :
                                i.value = value
                                break
                        }
                    }
                })

            },
            submit() {

                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.fillForm()
                        this.formEl.submit()
                    }
                })
            }
        }
    }
</script>
